/* eslint no-eval: "off" */
import { FunctionComponent } from 'react';

const Image: FunctionComponent<IGlassImage> = (props: IGlassImage) => {
  const onEnterUseFunction = (event: any) => {
    if (event.key === 'Enter') {
      props.onClick();
    }
  };

  const getWrapperId = () => {
    let wrapperId = props.Alt ? props.Alt : props.Title ?? '';
    return wrapperId ? 'img_' + wrapperId.replaceAll(' ', '') : '';
  };

  return (
    <>
      <div id={getWrapperId()}>
        <img
          onClick={props.onClick}
          onKeyPress={onEnterUseFunction}
          alt={props.Alt}
          className={props.Class}
          height={props.Height > 0 ? props.Height : undefined}
          width={props.Width > 0 ? props.Width : undefined}
          title={props.Title}
          src={props.Src}
          tabIndex={props.Tabable ? 0 : -1}
        />
      </div>
    </>
  );
};

export default Image;
